// import React from 'react';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement,
//   ArcElement,
//   Title,
//   Tooltip,
//   Legend,
//   TimeScale,
// } from 'chart.js';
// import { Bar, Line, Pie, Doughnut } from 'react-chartjs-2';
// import 'chartjs-adapter-date-fns';
// import { Card, CardHeader, CardContent } from '@/components/ui/Card';
// import { TrendingUp, BarChart3, PieChart } from 'lucide-react';

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement,
//   ArcElement,
//   Title,
//   Tooltip,
//   Legend,
//   TimeScale
// );

// interface ChartRendererProps {
//   type: string;
//   data: Record<string, any>[];
//   title: string;
//   className?: string;
// }

// export const ChartRenderer: React.FC<ChartRendererProps> = ({
//   type,
//   data,
//   title,
//   className,
// }) => {
//   if (!data || data.length === 0) {
//     return (
//       <Card className={className}>
//         <CardContent>
//           <div className="flex flex-col items-center justify-center py-12 text-center">
//             <div className="w-16 h-16 bg-secondary-100 rounded-2xl flex items-center justify-center mb-4">
//               <BarChart3 className="w-8 h-8 text-secondary-400" />
//             </div>
//             <p className="text-secondary-500 font-medium">No data available for visualization</p>
//             <p className="text-sm text-secondary-400 mt-1">Try adjusting your query parameters</p>
//           </div>
//         </CardContent>
//       </Card>
//     );
//   }

//   // Improved logic to extract keys for x and y axes
//   const keys = Object.keys(data[0]);
  
//   // For time series data, prioritize the 'period' field
//   let xKey: string;
//   let yKey: string;
  
//   if (type.toLowerCase() === 'line' && keys.includes('period')) {
//     // For line charts with period field, use period as x-axis
//     xKey = 'period';
//     yKey = keys.find(k => k !== 'period' && ['total', 'value', 'y', 'count', 'total_sales', 'sales', 'amount'].some(metric => k.toLowerCase().includes(metric))) || 
//            keys.find(k => k !== 'period' && typeof data[0][k] === 'number') ||
//            keys.find(k => k !== 'period') || keys[0];
//   } else {
//     // For other chart types, use the original logic
//     xKey = keys.find(k => !['total', 'value', 'y', 'count', 'total_sales', 'sales', 'amount'].includes(k.toLowerCase())) || keys[0];
//     yKey = keys.find(k => ['total', 'value', 'y', 'count', 'total_sales', 'sales', 'amount'].includes(k.toLowerCase())) || 
//            keys.find(k => typeof data[0][k] === 'number') ||
//            keys[1];
//   }

//   // Sort data by period for line charts to ensure proper time sequence
//   let sortedData = [...data];
//   if (type.toLowerCase() === 'line' && xKey === 'period') {
//     sortedData.sort((a, b) => {
//       const periodA = String(a[xKey] || '');
//       const periodB = String(b[xKey] || '');
//       return periodA.localeCompare(periodB);
//     });
//   }

//   const chartData = {
//     labels: sortedData.map((d: any) => String(d[xKey])),
//     datasets: [
//       {
//         label: title,
//         data: sortedData.map((d: any) => Number(d[yKey]) || 0),
//         backgroundColor: [
//           'rgba(59, 130, 246, 0.8)',
//           'rgba(16, 185, 129, 0.8)',
//           'rgba(245, 158, 11, 0.8)',
//           'rgba(239, 68, 68, 0.8)',
//           'rgba(139, 92, 246, 0.8)',
//           'rgba(236, 72, 153, 0.8)',
//           'rgba(6, 182, 212, 0.8)',
//           'rgba(34, 197, 94, 0.8)',
//           'rgba(168, 85, 247, 0.8)',
//           'rgba(251, 146, 60, 0.8)',
//         ],
//         borderColor: [
//           'rgba(59, 130, 246, 1)',
//           'rgba(16, 185, 129, 1)',
//           'rgba(245, 158, 11, 1)',
//           'rgba(239, 68, 68, 1)',
//           'rgba(139, 92, 246, 1)',
//           'rgba(236, 72, 153, 1)',
//           'rgba(6, 182, 212, 1)',
//           'rgba(34, 197, 94, 1)',
//           'rgba(168, 85, 247, 1)',
//           'rgba(251, 146, 60, 1)',
//         ],
//         borderWidth: 2,
//         borderRadius: type === 'bar' ? 6 : 0,
//         tension: type === 'line' ? 0.4 : 0,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         position: 'top' as const,
//         labels: {
//           usePointStyle: true,
//           padding: 20,
//           font: {
//             size: 12,
//             weight: 500,
//           },
//           color: '#374151',
//         },
//       },
//       title: {
//         display: false,
//       },
//       tooltip: {
//         backgroundColor: 'rgba(17, 24, 39, 0.95)',
//         titleColor: 'white',
//         bodyColor: 'white',
//         borderColor: 'rgba(75, 85, 99, 0.2)',
//         borderWidth: 1,
//         cornerRadius: 12,
//         padding: 16,
//         titleFont: {
//           size: 14,
//           weight: 600,
//         },
//         bodyFont: {
//           size: 13,
//           weight: 500,
//         },
//         displayColors: true,
//         usePointStyle: true,
//       },
//     },
//     scales: type !== 'pie' && type !== 'doughnut' ? {
//       x: {
//         grid: {
//           display: false,
//         },
//         ticks: {
//           font: {
//             size: 11,
//             weight: 500,
//           },
//           color: '#6B7280',
//         },
//         border: {
//           display: false,
//         },
//       },
//       y: {
//         beginAtZero: true,
//         grid: {
//           color: 'rgba(156, 163, 175, 0.1)',
//           drawBorder: false,
//         },
//         ticks: {
//           font: {
//             size: 11,
//             weight: 500,
//           },
//           color: '#6B7280',
//           padding: 8,
//         },
//         border: {
//           display: false,
//         },
//       },
//     } : undefined,
//     elements: {
//       point: {
//         radius: 6,
//         hoverRadius: 8,
//         backgroundColor: 'white',
//         borderWidth: 3,
//       },
//       line: {
//         borderWidth: 3,
//       },
//     },
//   };

//   const getChartIcon = () => {
//     switch (type.toLowerCase()) {
//       case 'line':
//         return <TrendingUp className="w-5 h-5 text-primary-600" />;
//       case 'pie':
//       case 'doughnut':
//         return <PieChart className="w-5 h-5 text-primary-600" />;
//       default:
//         return <BarChart3 className="w-5 h-5 text-primary-600" />;
//     }
//   };

//   const renderChart = () => {
//     switch (type.toLowerCase()) {
//       case 'bar':
//         return <Bar data={chartData} options={options} />;
//       case 'line':
//         return <Line data={chartData} options={options} />;
//       case 'pie':
//         return <Pie data={chartData} options={options} />;
//       case 'doughnut':
//         return <Doughnut data={chartData} options={options} />;
//       default:
//         return <Bar data={chartData} options={options} />;
//     }
//   };

//   return (
//     <Card className={className}>
//       <CardHeader>
//         <div className="flex items-center gap-3">
//           <div className="w-10 h-10 bg-gradient-to-br from-primary-100 to-primary-200 rounded-xl flex items-center justify-center">
//             {getChartIcon()}
//           </div>
//           <div>
//             <h3 className="text-lg font-bold text-secondary-900">{title}</h3>
//             <p className="text-sm text-secondary-600 font-medium">
//               {data.length} data point{data.length !== 1 ? 's' : ''}
//             </p>
//           </div>
//         </div>
//       </CardHeader>
//       <CardContent>
//         <div className="h-80 relative">
//           <div className="absolute inset-0 bg-gradient-to-br from-secondary-50/30 to-primary-50/30 rounded-lg -z-10"></div>
//           {renderChart()}
//         </div>
//       </CardContent>
//     </Card>
//   );
// };

import React, { useRef } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from 'chart.js';
import { Bar, Line, Pie, Doughnut } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { TrendingUp, BarChart3, PieChart, Download } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { useLanguage } from '@/i18n/LanguageContext';
import { CHART_BORDER_PALETTE, CHART_PALETTE } from '@/components/chartPalette';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

// Improve canvas resolution on HiDPI / Retina displays so chart text and lines render sharply
if (typeof window !== 'undefined') {
  ChartJS.defaults.devicePixelRatio = Math.max(window.devicePixelRatio || 1, 2);
}

interface ChartRendererProps {
  type: string;
  data: Record<string, any>[];
  title: string;
  className?: string;
}

export const ChartRenderer: React.FC<ChartRendererProps> = ({
  type,
  data,
  title,
  className,
}) => {
  const { language } = useLanguage();
  const uiText = React.useMemo(
    () =>
      language === 'am'
        ? {
            noData: 'ለማሳየት የሚችል ውሂብ የለም',
            groupedBy: 'በዚህ ተመድቧል',
            coloredBy: 'በቀለም ተለይቷል',
            downloadChart: 'የቻርት ምስል አውርድ',
            download: 'አውርድ',
          }
        : {
            noData: 'No data available for visualization',
            groupedBy: 'Grouped by',
            coloredBy: 'colored by',
            downloadChart: 'Download chart image',
            download: 'Download',
          },
    [language]
  );
  const chartRef = useRef<ChartJS<any, any, any> | null>(null);
  const setChartRef = (chart: ChartJS<any, any, any> | undefined | null) => {
    chartRef.current = chart ?? null;
  };
  if (!data || data.length === 0) {
    return (
      <Card className={className}>
        <CardContent>
          <div className="flex flex-col items-center justify-center py-8 text-center">
            <div className="w-12 h-12 bg-secondary-100 rounded-xl flex items-center justify-center mb-3">
              <BarChart3 className="w-6 h-6 text-secondary-400" />
            </div>
            <p className="text-sm text-secondary-500 font-medium">{uiText.noData}</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  /* ------------------------------------------------------------------ */
  /* 1. Detect numeric (Y) key                                           */
  /* ------------------------------------------------------------------ */

  const yKey =
    Object.keys(data[0]).find(
      k => typeof data[0][k] === 'number'
    ) ?? 'value';

  /* ------------------------------------------------------------------ */
  /* 2. Detect categorical fields & rank by cardinality                  */
  /* ------------------------------------------------------------------ */

  const categoricalKeys = Object.keys(data[0])
    .filter(k => k !== yKey && typeof data[0][k] === 'string')
    .map(k => ({
      key: k,
      uniqueCount: new Set(data.map(d => d[k])).size,
    }))
    .sort((a, b) => b.uniqueCount - a.uniqueCount);

  const xKey = categoricalKeys[0]?.key;
  const seriesKey = categoricalKeys[1]?.key;

  /* ------------------------------------------------------------------ */
  /* 3. Build labels (X-axis)                                            */
  /* ------------------------------------------------------------------ */

  const labels = xKey
    ? Array.from(new Set(data.map(d => d[xKey])))
    : [];

  /* ------------------------------------------------------------------ */
  /* 4. Build datasets                                                   */
  /* ------------------------------------------------------------------ */

  const palette = CHART_PALETTE;
  const isPie = ['pie', 'doughnut'].includes(type.toLowerCase());

  let datasets: any[] = [];

  if (isPie) {
    // For pie/doughnut charts we want a single dataset where each label
    // becomes a slice. Sum values per label to handle multiple rows.
    const pieData = labels.map(label =>
      data
        .filter(d => d[xKey] === label)
        .reduce((sum, row) => sum + (Number(row[yKey]) || 0), 0)
    );

    datasets = [
      {
        label: title,
        data: pieData,
        backgroundColor: labels.map((_, i) => palette[i % palette.length]),
        borderColor: CHART_BORDER_PALETTE,
        borderWidth: 1,
      },
    ];
  } else if (seriesKey) {
    // One colour per measure (series), held stable across every label.
    datasets = Array.from(new Set(data.map(d => d[seriesKey]))).map(
      (seriesValue, idx) => ({
        label: seriesValue,
        data: labels.map(label => {
          const row = data.find(
            d => d[xKey] === label && d[seriesKey] === seriesValue
          );
          return row ? Number(row[yKey]) : 0;
        }),
        backgroundColor: palette[idx % palette.length],
        borderColor: CHART_BORDER_PALETTE[idx % CHART_BORDER_PALETTE.length],
        borderWidth: 1,
        borderRadius: type === 'bar' ? 6 : 0,
      })
    );
  } else {
    // One measure, one colour: the same hue across every bar so the length of
    // the bar, not its hue, carries the comparison. Per-bar colour is reserved
    // for pie and doughnut, where the slice position has no numeric meaning.
    datasets = [
      {
        label: title,
        data: labels.map(label => {
          const rows = data.filter(d => d[xKey] === label);
          return rows.reduce((s, r) => s + (Number(r[yKey]) || 0), 0);
        }),
        backgroundColor: palette[0],
        borderColor: CHART_BORDER_PALETTE[0],
        borderWidth: 1,
        borderRadius: type === 'bar' ? 6 : 0,
      },
    ];
  }


  /* ------------------------------------------------------------------ */
  /* 5. Chart.js config                                                  */
  /* ------------------------------------------------------------------ */

  const chartData = {
    labels,
    datasets,
  };

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: '#000000',
          boxWidth: 10,
          padding: 10,
          font: { size: 10 },
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'rgba(255,255,255,0.95)',
        borderColor: 'rgba(0,0,0,0.08)',
        borderWidth: 1,
        cornerRadius: 8,
        padding: 8,
        titleColor: '#000000',
        bodyColor: '#000000',
        titleFont: { size: 11, weight: 600 },
        bodyFont: { size: 10, weight: 500 },
      },
    },
    scales:
      type !== 'pie' && type !== 'doughnut'
        ? {
            x: {
              stacked: false,
              ticks: {
                autoSkip: true,
                maxRotation: 45,
                color: '#000000',
                font: {
                  size: 10,
                  weight: 500,
                },
              },
            },
            y: {
              beginAtZero: true,
              ticks: {
                font: {
                  size: 10,
                  weight: 500,
                },
                color: '#000000',
                padding: 6,
              },
            },
          }
        : undefined,
  };

  /* ------------------------------------------------------------------ */
  /* 6. Render chart                                                     */
  /* ------------------------------------------------------------------ */

  const renderChart = () => {
    switch (type.toLowerCase()) {
      case 'line':
        return <Line ref={setChartRef} data={chartData} options={options} />;
      case 'pie':
        return <Pie ref={setChartRef} data={chartData} options={options} />;
      case 'doughnut':
        return <Doughnut ref={setChartRef} data={chartData} options={options} />;
      default:
        return <Bar ref={setChartRef} data={chartData} options={options} />;
    }
  };

  const getChartIcon = () => {
    switch (type.toLowerCase()) {
      case 'line':
        return <TrendingUp className="w-4 h-4 text-primary-600" />;
      case 'pie':
      case 'doughnut':
        return <PieChart className="w-4 h-4 text-primary-600" />;
      default:
        return <BarChart3 className="w-4 h-4 text-primary-600" />;
    }
  };

  const handleDownload = () => {
    if (!chartRef.current) return;
    const rawName = title?.trim() || 'chart';
    const safeName =
      rawName.replace(/[^a-z0-9-_]+/gi, '_').replace(/^_+|_+$/g, '') ||
      'chart';
    const url = chartRef.current.toBase64Image();
    const link = document.createElement('a');
    link.href = url;
    link.download = `${safeName}.png`;
    link.click();
  };

  return (
    <Card className={className}>
      <CardHeader>
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center">
              {getChartIcon()}
            </div>
            <div>
              <h3 className="text-sm font-bold">{title}</h3>
              <p className="text-xs text-secondary-600">
                {uiText.groupedBy} <b>{xKey}</b>
                {seriesKey && (
                  <>
                    {' '}
                    - {uiText.coloredBy} <b>{seriesKey}</b>
                  </>
                )}
              </p>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={handleDownload}
            className="flex h-8 items-center gap-1.5 px-2.5 text-xs"
            title={uiText.downloadChart}
          >
            <Download className="w-3.5 h-3.5" />
            {uiText.download}
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="h-60">{renderChart()}</div>
      </CardContent>
    </Card>
  );
};
